import CustomButton from "../../../../components/lib/customButton";

const EditableStudentsList = ({ students, onRemove }) => {
    return (
        <div className="flex flex-col gap-2">
            <p className="text-sm font-semibold text-custom_gray_font">
                Alunos vinculados
            </p>

            <div className="space-y-2 max-h-64 overflow-y-auto">
                {students.length === 0 && (
                    <p className="text-sm text-center text-gray-400 py-4">
                        Nenhum aluno vinculado
                    </p>
                )}

                {students.map((s) => (
                    <div
                        key={s.id}
                        className="flex items-center justify-between
                                   bg-white border rounded-md
                                   px-3 py-2"
                    >
                        <div className="flex flex-col overflow-hidden">
                            <span className="text-sm font-medium truncate">
                                {s.name}
                            </span>
                            <span className="text-xs text-gray-400 truncate">
                                {s.login}
                            </span>
                        </div>

                        <CustomButton
                            buttonType="delete"
                            text="Remover"
                            onClick={() => onRemove(s)}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EditableStudentsList;
